import ExternalPage from "./Externalpage";

export const API = (props) => {
  return (
    <div id="service" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>API 서비스</h2>
          <p>
            DOHC와 선회반경에 대해서 S-100 기반의 데이터 (FC, PC, GML)의 데이터를 제공하기 위한 API 서비스입니다.
          </p>
          <p>
            사용자 편의를 제공하기 위해서 Swagger를 제공합니다.
          </p>
          <h3>
            <a
              href="https://geoapi.s100lab.com/api-docs"
              target="_blank"
              rel="noreferrer"
              style={{ fontWeight: "bold", color: "#2563eb", textDecoration: "underline" }}
            >
              https://geoapi.s100lab.com/api-docs
            </a>
          </h3>
        </div>
        <div className="row">
          <div className="service-items">
            <ExternalPage src="https://geoapi.s100lab.com/api-docs" title="Geostory API Service" />
          </div>
        </div>
      </div>
    </div>
  );
};
